export default "/images/f21729b9f12bedf52aebc76fa3be0d87.avif";